export const Steps = ({ img, heading, subHeading }) => (
  <div className="lil-flex lil-pt-0 lil-w-full">
    <div className="lil-w-1/6 xl:lil-w-1/12 lil-m-1">
      <img src={img} height="60" width="60" />
    </div>
    <div className="lil-px-6 lil-w-5/6">
      <p className="lil-text-font-500 lil-font-bold lil-text-lg">{heading}</p>
      <p className="lil-text-base lil-pt-2">{subHeading}</p>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/stepsToInvest/steps.tsx